import { DnpBadge } from '#components/dnp-badge.js';
import { useProjectModule } from '#components/model-module-chip/use-project-module.js';
import { useIsModuleDnp } from '#utils/use-is-module-dnp.js';

export interface ModuleMiniCardProps {
	/** The hovered placement's reference designator (instance-level for multi-unit parts). */
	moduleReferenceDesignator: string;
}

/**
 * A miniature module info card for the renderer's hover tooltip: the reference designator, the
 * module's value or model when known, and its DNP status.
 */
export function ModuleMiniCard({ moduleReferenceDesignator }: ModuleMiniCardProps) {
	const projectModule = useProjectModule(moduleReferenceDesignator);
	const projectReferenceDesignator = projectModule?.name ?? moduleReferenceDesignator;
	const isDnp = useIsModuleDnp(projectReferenceDesignator, projectModule);
	const detail = projectModule?.value ?? projectModule?.model?.modelId;

	return (
		<div className='flex max-w-72 items-baseline gap-2 whitespace-nowrap'>
			<span className='font-mono text-sm leading-tight font-bold'>{moduleReferenceDesignator}</span>
			{detail !== undefined && <span className='truncate min-w-0 text-sm text-gray-a11'>{detail}</span>}
			{isDnp && <DnpBadge className='self-center' />}
		</div>
	);
}
